import { getOnZzim } from '@/common/converter/utils/get-event-property'
import { restEventCommonParams } from '@/common/converter/const'

export const convertEventOnZzim = (elementList = []) => {
  const { type, url, method, bodyJSON, isRender } = getOnZzim(elementList)

  if (!isRender) return undefined

  return {
    type,
    url,
    method,
    bodyjson: bodyJSON,
    ...restEventCommonParams,
  }
}
